import React from 'react';
import Icon from '../Icon';
import SwitchBase from '../SwitchBase';
import { IconColors, IconBackgroundColors, IconVariants, } from '../../constants';
import CameraOnIcon from '../../assets/icons/camera-on.svg';
import CameraOffIcon from '../../assets/icons/camera-off.svg';
const SwitchCamera = ({ size, variant, disabled, isActive, switchHandle }) => {
    const icon = (<Icon size={size} color={IconColors.Primary} backgroundColor={IconBackgroundColors.Secondary} variant={isActive ? variant : IconVariants.Rounded}>
      {isActive
            ? <CameraOnIcon />
            : <CameraOffIcon />}
    </Icon>);
    return (<SwitchBase activeElement={icon} inactiveElement={icon} isActive={isActive} disabled={disabled} switchHandle={switchHandle}/>);
};
export default SwitchCamera;
